import {
  Box,
  Grid2,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import ClaimRow from "./ClaimRow";

import IconButton from "@mui/material/IconButton";
import TablePagination from "@mui/material/TablePagination";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import SimResultsListHeader from "./SimResultsListHeader";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import CloseIcon from "@mui/icons-material/Close";
import { Info } from "@mui/icons-material";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ border: 0, flexShrink: 0, ml: 2 }}>
      <IconButton
        sx={{ color: "secondary.main" }}
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        sx={{ color: "secondary.main" }}
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        sx={{ color: "secondary.main" }}
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        sx={{ color: "secondary.main" }}
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function SimResultsList({
  type_of_claim,
  data,
  setFilteredResults,
  originalData,
}) {
  // console.log("DATA:");
  // console.log(data);
  // const thresholds =
  //   data.length > 0
  //     ?  Object.entries(data[0].total_tasks.new_mail_to_new_mail): [];

  const columnsCount = 3;

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Ref and state for dynamically calculating the height of the first header row
  const firstHeaderRef = useRef(null);
  const [firstHeaderHeight, setFirstHeaderHeight] = React.useState(0);

  useEffect(() => {
    if (firstHeaderRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        setFirstHeaderHeight(firstHeaderRef.current.offsetHeight);
      });

      resizeObserver.observe(firstHeaderRef.current);

      return () => resizeObserver.disconnect();
    }
  }, [firstHeaderRef]);

  // These are for the Info Icon Button in Header
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const InfoOpen = Boolean(anchorEl);
  //--------------------------------------------
  return (
    <Box
      sx={{
        border: 5,
        borderRadius: 3,
        borderColor: "lightgray",
        width: "100%",
        height: "100%",
        // maxHeight: "85xvh",
        minWidth: 500,
        maxWidth: 800,
        position: "relative",
      }}
    >
      <TableContainer
        sx={{
          // border: 5,
          // borderRadius: 3,
          // borderColor: "lightgray",
          // width: "100%",
          maxHeight: "78vh",
          // minWidth: 700,
        }}
      >
        <Table stickyHeader>
          <TableHead colSpan={columnsCount}>
            <TableRow
              ref={firstHeaderRef}
              colSpan={columnsCount}
              sx={{
                position: "sticky",
                zIndex: 1,
                border: 1,
                borderColor: "red",
              }}
            >
              <TableCell
                size="small"
                colSpan={columnsCount}
                align="center"
                sx={{
                  py: 1,
                  px: 0.5,
                  bgcolor: "lightgray",
                  borderBottom: 0,
                  borderColor: "secondary.main",
                }}
              >
                <Grid2 container sx={{ width: "100%" }}>
                  <Grid2
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                    }}
                    size="grow"
                  >
                    {/* <Stack spacing={1}>
                      <SortMenu
                        data={data}
                        setFilteredResults={setFilteredResults}
                        // resetResults={resetResults}
                        // thresholds={thresholds}
                      />
                      <FilterMenu
                        originalData={originalData}
                        setFilteredResults={setFilteredResults}
                        // resetResults={resetResults}
                        // thresholds={thresholds}
                      />
                    </Stack> */}
                  </Grid2>
                  <Grid2
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "secondary.main",
                    }}
                  >
                    <Stack spacing={1}>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ justifyContent:"center"}}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 26 }}>
                          {type_of_claim} Results
                        </Typography>
                        {/* Info Icon Button */}
                        <IconButton
                          size="small"
                          onClick={handleInfoClick}
                          aria-label="Information"
                          sx={{ color: "secondary.main" }}
                        >
                          <InfoOutlinedIcon />
                        </IconButton>
                      </Stack>
                      <Stack spacing={1} direction={"row"}>
                        <Typography
                          sx={{ fontSize: 16, color: "secondary.main" }}
                        >
                          900 Claims
                        </Typography>
                        <Typography
                          sx={{ fontSize: 16, color: "secondary.main" }}
                        >
                          {" \u2022 "}
                        </Typography>
                        <Typography
                          sx={{ fontSize: 16, color: "secondary.main" }}
                        >
                          {data.length} with Similar Comparisons
                        </Typography>
                      </Stack>
                    </Stack>
                    <Popover
                      open={InfoOpen}
                      anchorEl={anchorEl}
                      onClose={handleInfoClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      PaperProps={{ sx: { p: 2, maxWidth: 300 } }}
                    >
                      <ClickAwayListener onClickAway={handleInfoClose}>
                        <Stack direction="row" alignItems="start" spacing={1}>
                        <IconButton size="small" onClick={handleInfoClose}>
                            <CloseIcon fontSize="medium" />
                          </IconButton>
                          <Typography variant="body1" sx={{ flex: 1 }}>
                            {/* Your info message goes here */}
                            The simulation was ran on 900 {type_of_claim} Claims. {data.length} Claims had Similar Comparisons which are shown in this UI.
                          </Typography>
                          
                        </Stack>
                      </ClickAwayListener>
                    </Popover>
                  </Grid2>
                  <Grid2 size="grow" />
                </Grid2>
              </TableCell>
            </TableRow>
            <SimResultsListHeader
              firstHeaderHeight={firstHeaderHeight}
              setFilteredResults={setFilteredResults}
              data={data}
            />
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((item) => (
              <ClaimRow
                hover={true}
                key={item.claim_id}
                item={item}
                columnsCount={columnsCount}
                // thresholds={thresholds}
                back_link={type_of_claim === "Auto" ? "/" : "/fire"}
              />
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={columnsCount} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          width: "100%",
          backgroundColor: "lightgray",
          // backgroundColor: "white",
          borderTop: 3,
          borderTopColor: "secondary.main",
        }}
      >
        <TablePagination
          rowsPerPageOptions={[
            10,
            25,
            50,
            100,
            500,
            { label: "All", value: -1 },
          ]}
          colSpan={columnsCount}
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          slotProps={{
            select: {
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            },
          }}
          sx={{
            p: 0,
            m: 0,
            // backgroundColor: "lightgray",
            border: 0,
            display: "flex",
            justifyContent: "center",
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>
    </Box>
  );
}

export default SimResultsList;
